import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
const Center = forwardRef((props, ref) => {
    return React.createElement(Container, { ...props, ref: ref });
});
Center.displayName = 'Center';
export default Center;
const Container = styled.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
